import React from "react";
import { Card } from "antd";

interface StatCardProps {
  image: string;
  title: string;
  count: any;
}

const StatCard: React.FC<StatCardProps> = ({ image, title, count }) => {
  return (
    <Card className="p-4 shadow-lg flex flex-col sm:flex-row items-center sm:items-start h-auto !rounded-2xl hover:shadow-xl transition-shadow duration-300 max-w-md cursor-pointer mb-6">
      <div className="flex sm:flex-row flex-col sm:justify-between w-full h-full">
        {/* Image section */}
        <div className="mb-4 sm:mb-0 sm:mr-6 flex justify-center sm:justify-start h-full">
          <img
            src={image}
            alt={title}
            className="w-16 h-16 object-cover rounded-lg"
          />
        </div>
        {/* Title and count section */}
        <div className="flex flex-col justify-between sm:items-start text-center sm:text-left">
          <span className="text-lg sm:text-xl break-words">{title}</span>
          <span className="text-2xl font-bold" style={{ color: '#712B90' }}>
            {count}
          </span>
        </div>
      </div>
    </Card>


  
  );
};

export default StatCard;
